// ===== Global routes =====
import { ArticleSearchCondition } from '@/common/api/modules/articles'
import { MediaActionSearchCondition } from '@/common/api/modules/mediaAction'
import { makeParamsQueryStr } from '@/common/api/rest'
import { MasterType } from '@/common/model/master/w2Master'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

export const loginPath = () => '/login'

export const selectModePath = () => '/select-mode'

export const proposalPath = () => '/proposal'

export const proposal2Path = () => '/proposal2'

export const proposal3Path = () => '/proposal3'

export const proposal4Path = () => '/proposal4'

export const dashboardPath = () => '/dashboard'

export const analyticsPath = () => '/analytics'

export const siteListPath = () => '/sites'

export const siteNewPath = () => '/sites/new'

export const siteEditPath = (siteId: number) => `/sites/${siteId}`

export const operatorListPath = () => '/operators'

export const operatorNewPath = () => '/operators/new'

export const operatorEditPath = (operatorId: number) => `/operators/${operatorId}`

export const systemConfigPath = () => '/system-config'

export const w2CommerceLinkPath = () => '/w2-commerce-link'

export const promotionKarteConfigPath = () => '/promotion-karte-config'

export const siteUsagePath = () => '/site-usage'

export const billingPath = () => '/billing'

export const auditLogsPath = () => '/audit-logs'

export const personaCatalogPath = () => '/persona-catalog'

export const linkageApiKeyListPath = () => '/linkage-api-keys'

export const linkageApiKeyNewPath = () => '/linkage-api-keys/new'

export const linkageApiKeyEditPath = (linkageApiKeyId: number) =>
  `/linkage-api-keys/${linkageApiKeyId}/edit`

export const supportSpecPath = () => '/support-spec'

export const featureListPath = () => '/feature-list'

// ===== Site-scoped routes =====

export const widgetListPath = (siteId: number) => `/sites/${siteId}/recommend/widgets`

export const widgetNewPath = (siteId: number) => `/sites/${siteId}/recommend/widgets/new`

export const widgetEditPath = (siteId: number, widgetId: number) =>
  `/sites/${siteId}/recommend/widgets/edit/${widgetId}`

export const siteOperatorListPath = (siteId: number) => `/sites/${siteId}/settings/operators`

export const siteOperatorNewPath = (siteId: number) => `/sites/${siteId}/settings/operators/new`

export const siteOperatorEditPath = (siteId: number, operatorId: number) =>
  `/sites/${siteId}/settings/operators/${operatorId}/edit`

export const permissionTemplateListPath = (siteId: number) =>
  `/sites/${siteId}/settings/permissions`

export const permissionTemplateNewPath = (siteId: number) =>
  `/sites/${siteId}/settings/permissions/new`

export const permissionTemplateEditPath = (siteId: number, templateId: number) =>
  `/sites/${siteId}/settings/permissions/${templateId}/edit`

export const widgetPageListPath = (siteId: number) => `/sites/${siteId}/recommend/widget-pages`

export const widgetPageNewPath = (siteId: number) => `/sites/${siteId}/recommend/widget-pages/new`

export const widgetPageEditPath = (siteId: number, widgetPageId: number) =>
  `/sites/${siteId}/recommend/widget-pages/${widgetPageId}/edit`

export const distributionListPath = (siteId: number) => `/sites/${siteId}/recommend/distributions`

export const distributionNewPath = (siteId: number) =>
  `/sites/${siteId}/recommend/distributions/new`

export const distributionEditPath = (siteId: number, distributionId: number) =>
  `/sites/${siteId}/recommend/distributions/${distributionId}/edit`

export const distributionAbCampaignPath = (siteId: number, distributionId: number) =>
  `/sites/${siteId}/recommend/distributions/${distributionId}/ab-campaign`

export const tagsPath = (siteId: number) => `/sites/${siteId}/recommend/tags`

export const deliveryStatsPath = (siteId: number) =>
  `/sites/${siteId}/recommend/dashboard/delivery-stats`

export const orderHistoryPath = (siteId: number) => `/sites/${siteId}/recommend/order-history`

export const behaviorPath = (siteId: number) => `/sites/${siteId}/recommend/behavior`

export const customersPath = (siteId: number) => `/sites/${siteId}/recommend/customers`


export const siteDashboardPath = (siteId: number) => `/sites/${siteId}/recommend/dashboard`

export const setupGuidePath = (siteId: number) => `/sites/${siteId}/recommend/setup-guide`

export const modelTuningPath = (siteId: number) => `/sites/${siteId}/recommend/model-tuning`

export const fileUploadPath = (siteId: number) => `/sites/${siteId}/file-upload`

export const masterSummaryPath = (siteId: number) => `/sites/${siteId}/master-summary`

// API連携（W2 OpenAPI 送信）
export const w2SendStatusPath = (siteId: number) => `/sites/${siteId}/w2-send-status`

export const targetListPath = (siteId: number) => `/sites/${siteId}/send-data/target-list`

export const promotionOutboxPath = (siteId: number) => `/sites/${siteId}/send-data/promotion-outbox`

export const productUnderstandingPath = (siteId: number) => `/sites/${siteId}/product-understanding`

export const externalArticlePath = (siteId: number) => `/sites/${siteId}/external-articles`
export const w2ReviewSyncPath = (siteId: number) => `/sites/${siteId}/w2-review-sync`
export const productInfoUsagePath = (siteId: number) => `/sites/${siteId}/product-info-usage`

export const personaLibraryPath = (siteId: number) => `/sites/${siteId}/persona/library`

export const personaAssignmentPath = (siteId: number) => `/sites/${siteId}/persona/assignment`

export const personaHealthPath = (siteId: number) => `/sites/${siteId}/persona/health`

export const personaTrendPath = (siteId: number) => `/sites/${siteId}/persona/trend`

export const aiTagsPath = (siteId: number) => `/sites/${siteId}/recommend/ai-tags`

export const aiTagNewPath = (siteId: number) => `/sites/${siteId}/recommend/ai-tags/new`

export const aiTagEditPath = (siteId: number, tagId: number) =>
  `/sites/${siteId}/recommend/ai-tags/edit/${tagId}`

export const passwordChangePath = (siteId: number) => `/sites/${siteId}/password-change`

// ===== W2 Master routes =====

export const w2UsersPath = (siteId: number) => `/sites/${siteId}/w2-users`

export const w2UserAttributesPath = (siteId: number) => `/sites/${siteId}/w2-user-attributes`

export const w2MemberRanksPath = (siteId: number) => `/sites/${siteId}/w2-member-ranks`

export const w2AccessLogsPath = (siteId: number) => `/sites/${siteId}/w2-access-logs`

export const w2ProductsPath = (siteId: number) => `/sites/${siteId}/w2-products`

export const w2ProductLinksPath = (siteId: number) => `/sites/${siteId}/w2-product-links`

// 拡張マスタ（add-w2-ex-product-spec で追加）
export const w2ExProductSpecsPath = (siteId: number) => `/sites/${siteId}/w2-ex-product-specs`

export const w2ExProductVariationSpecsPath = (siteId: number) =>
  `/sites/${siteId}/w2-ex-product-variation-specs`

export const w2ProductBrandsPath = (siteId: number) => `/sites/${siteId}/w2-product-brands`

export const w2ProductCategoriesPath = (siteId: number) => `/sites/${siteId}/w2-product-categories`

export const w2ProductTagsPath = (siteId: number) => `/sites/${siteId}/w2-product-tags`

// 商品タグ設定マスター（add-w2-product-tag-setting で追加）
export const w2ProductTagSettingsPath = (siteId: number) =>
  `/sites/${siteId}/w2-product-tag-settings`

export const w2ProductInventoryPath = (siteId: number) => `/sites/${siteId}/w2-product-inventory`

export const w2ProductVariationPath = (siteId: number) => `/sites/${siteId}/w2-product-variation`

export const w2ProductPricePath = (siteId: number) => `/sites/${siteId}/w2-product-price`

export const w2CartPath = (siteId: number) => `/sites/${siteId}/w2-cart`

export const w2OrdersPath = (siteId: number) => `/sites/${siteId}/w2-orders`

export const w2OrderDetailsPath = (siteId: number) => `/sites/${siteId}/w2-order-details`

export const w2OrderCouponsPath = (siteId: number) => `/sites/${siteId}/w2-order-coupons`

export const w2CouponsPath = (siteId: number) => `/sites/${siteId}/w2-coupons`

export const w2AdvCodesPath = (siteId: number) => `/sites/${siteId}/w2-advcodes`

export const w2FeaturesPath = (siteId: number) => `/sites/${siteId}/w2-features`

export const w2FeatureCategoriesPath = (siteId: number) => `/sites/${siteId}/w2-feature-categories`

export const w2FeatureContentsPath = (siteId: number) => `/sites/${siteId}/w2-feature-contents`

export const w2ContentsTagsPath = (siteId: number) => `/sites/${siteId}/w2-contents-tags`

export const w2ProductGroupsPath = (siteId: number) => `/sites/${siteId}/w2-product-groups`

export const w2ProductGroupItemsPath = (siteId: number) => `/sites/${siteId}/w2-product-group-items`

// === 施策系マスタ（add-w2-marketing-master-tables） ===
export const w2UserPointPath = (siteId: number) => `/sites/${siteId}/w2-user-point`
export const w2UserPointHistoryPath = (siteId: number) => `/sites/${siteId}/w2-user-point-history`
export const w2PointRulePath = (siteId: number) => `/sites/${siteId}/w2-point-rule`
export const w2PointRuleSchedulePath = (siteId: number) => `/sites/${siteId}/w2-point-rule-schedule`
export const w2UserMemberRankHistoryPath = (siteId: number) =>
  `/sites/${siteId}/w2-user-member-rank-history`
export const w2MemberRankRulePath = (siteId: number) => `/sites/${siteId}/w2-member-rank-rule`
export const w2OrderShippingPath = (siteId: number) => `/sites/${siteId}/w2-order-shipping`
export const w2ShopShippingPath = (siteId: number) => `/sites/${siteId}/w2-shop-shipping`
export const w2ShopShippingZonePath = (siteId: number) => `/sites/${siteId}/w2-shop-shipping-zone`
export const w2ShopShippingSizeThresholdPath = (siteId: number) =>
  `/sites/${siteId}/w2-shop-shipping-size-threshold`
export const w2MailDistSettingPath = (siteId: number) => `/sites/${siteId}/w2-mail-dist-setting`
export const w2MailDistSentUserPath = (siteId: number) => `/sites/${siteId}/w2-mail-dist-sent-user`
export const w2MailSendLogPath = (siteId: number) => `/sites/${siteId}/w2-mail-send-log`
export const w2MailClickPath = (siteId: number) => `/sites/${siteId}/w2-mail-click`
export const w2MailClickLogPath = (siteId: number) => `/sites/${siteId}/w2-mail-click-log`
export const w2OrderWorkflowScenarioSettingPath = (siteId: number) =>
  `/sites/${siteId}/w2-order-workflow-scenario-setting`
export const w2NoveltyPath = (siteId: number) => `/sites/${siteId}/w2-novelty`
export const w2NoveltyGrantConditionsPath = (siteId: number) =>
  `/sites/${siteId}/w2-novelty-grant-conditions`
export const w2NoveltyGrantItemPath = (siteId: number) => `/sites/${siteId}/w2-novelty-grant-item`
export const w2NoveltyTargetItemPath = (siteId: number) => `/sites/${siteId}/w2-novelty-target-item`
export const w2OrderSetPromotionPath = (siteId: number) => `/sites/${siteId}/w2-order-setpromotion`
export const w2OrderSetPromotionItemPath = (siteId: number) =>
  `/sites/${siteId}/w2-order-setpromotion-item`
export const w2SetPromotionPath = (siteId: number) => `/sites/${siteId}/w2-setpromotion`
export const w2SetPromotionItemPath = (siteId: number) => `/sites/${siteId}/w2-setpromotion-item`
export const w2ProductBundlePath = (siteId: number) => `/sites/${siteId}/w2-product-bundle`
export const w2ProductBundleItemPath = (siteId: number) => `/sites/${siteId}/w2-product-bundle-item`
export const w2ProductSetPath = (siteId: number) => `/sites/${siteId}/w2-product-set`
export const w2ProductSetItemPath = (siteId: number) => `/sites/${siteId}/w2-product-set-item`
export const w2ProductSalePath = (siteId: number) => `/sites/${siteId}/w2-product-sale`
export const w2ProductSalePricePath = (siteId: number) => `/sites/${siteId}/w2-product-sale-price`
export const w2FixedPurchasePath = (siteId: number) => `/sites/${siteId}/w2-fixed-purchase`
export const w2FixedPurchaseItemPath = (siteId: number) => `/sites/${siteId}/w2-fixed-purchase-item`
export const w2FixedPurchaseHistoryPath = (siteId: number) =>
  `/sites/${siteId}/w2-fixed-purchase-history`
export const w2FixedPurchaseCancelReasonPath = (siteId: number) =>
  `/sites/${siteId}/w2-fixed-purchase-cancel-reason`
export const w2UserCouponPath = (siteId: number) => `/sites/${siteId}/w2-user-coupon`
export const w2UserCouponHistoryPath = (siteId: number) => `/sites/${siteId}/w2-user-coupon-history`
export const w2CouponUseUserPath = (siteId: number) => `/sites/${siteId}/w2-coupon-use-user`
export const w2CouponSchedulePath = (siteId: number) => `/sites/${siteId}/w2-coupon-schedule`
export const w2AdvCodeLogPath = (siteId: number) => `/sites/${siteId}/w2-advcode-log`
export const w2AdvCodeMediaTypePath = (siteId: number) => `/sites/${siteId}/w2-advcode-media-type`
export const w2UserActivityPath = (siteId: number) => `/sites/${siteId}/w2-user-activity`
export const w2AbTestPath = (siteId: number) => `/sites/${siteId}/w2-ab-test`
export const w2AbTestItemPath = (siteId: number) => `/sites/${siteId}/w2-ab-test-item`

// CMS系（add-w2-cms-master-tables で追加）
export const w2PageDesignPath = (siteId: number) => `/sites/${siteId}/w2-page-design`
export const w2PageDesignGroupPath = (siteId: number) => `/sites/${siteId}/w2-page-design-group`
export const w2PartsDesignPath = (siteId: number) => `/sites/${siteId}/w2-parts-design`
export const w2PartsDesignGroupPath = (siteId: number) => `/sites/${siteId}/w2-parts-design-group`
export const w2FeatureAreaPath = (siteId: number) => `/sites/${siteId}/w2-feature-area`
export const w2FeatureAreaBannerPath = (siteId: number) => `/sites/${siteId}/w2-feature-area-banner`
export const w2PopupPath = (siteId: number) => `/sites/${siteId}/w2-popup`
export const w2PopupDisplayPageSettingPath = (siteId: number) =>
  `/sites/${siteId}/w2-popup-display-page-setting`
export const w2PopupReportPath = (siteId: number) => `/sites/${siteId}/w2-popup-report`

export const w2MasterListPath = (siteId: number, masterType: MasterType): string => {
  switch (masterType) {
    case MasterType.ORDERS:
      return orderHistoryPath(siteId)
    case MasterType.W2_USER:
      return w2UsersPath(siteId)
    case MasterType.W2_USER_ATTRIBUTE:
      return w2UserAttributesPath(siteId)
    case MasterType.W2_MEMBER_RANK:
      return w2MemberRanksPath(siteId)
    case MasterType.W2_ACCESS_LOG:
      return w2AccessLogsPath(siteId)
    case MasterType.W2_PRODUCT:
      return w2ProductsPath(siteId)
    case MasterType.W2_PRODUCT_BRAND:
      return w2ProductBrandsPath(siteId)
    case MasterType.W2_PRODUCT_CATEGORY:
      return w2ProductCategoriesPath(siteId)
    case MasterType.W2_PRODUCT_TAG:
      return w2ProductTagsPath(siteId)
    case MasterType.W2_PRODUCT_TAG_SETTING:
      return w2ProductTagSettingsPath(siteId)
    case MasterType.W2_PRODUCT_STOCK:
      return w2ProductInventoryPath(siteId)
    case MasterType.W2_PRODUCT_VARIATION:
      return w2ProductVariationPath(siteId)
    case MasterType.W2_PRODUCT_PRICE:
      return w2ProductPricePath(siteId)
    case MasterType.W2_PRODUCT_LINK:
      return w2ProductLinksPath(siteId)
    case MasterType.W2_EX_PRODUCT_SPEC:
      return w2ExProductSpecsPath(siteId)
    case MasterType.W2_EX_PRODUCT_VARIATION_SPEC:
      return w2ExProductVariationSpecsPath(siteId)
    case MasterType.W2_CART:
      return w2CartPath(siteId)
    case MasterType.W2_ORDER:
      return w2OrdersPath(siteId)
    case MasterType.W2_ORDER_ITEM:
      return w2OrderDetailsPath(siteId)
    case MasterType.W2_ORDER_COUPON:
      return w2OrderCouponsPath(siteId)
    case MasterType.W2_COUPON:
      return w2CouponsPath(siteId)
    case MasterType.W2_ADV_CODE:
      return w2AdvCodesPath(siteId)
    case MasterType.W2_FEATURE_PAGE:
      return w2FeaturesPath(siteId)
    case MasterType.W2_FEATURE_PAGE_CATEGORY:
      return w2FeatureCategoriesPath(siteId)
    case MasterType.W2_FEATURE_PAGE_CONTENTS:
      return w2FeatureContentsPath(siteId)
    case MasterType.W2_PRODUCT_GROUP:
      return w2ProductGroupsPath(siteId)
    case MasterType.W2_PRODUCT_GROUP_ITEM:
      return w2ProductGroupItemsPath(siteId)
    case MasterType.W2_CONTENTS_TAG:
      return w2ContentsTagsPath(siteId)
    case MasterType.W2_USER_POINT:
      return w2UserPointPath(siteId)
    case MasterType.W2_USER_POINT_HISTORY:
      return w2UserPointHistoryPath(siteId)
    case MasterType.W2_POINT_RULE:
      return w2PointRulePath(siteId)
    case MasterType.W2_POINT_RULE_SCHEDULE:
      return w2PointRuleSchedulePath(siteId)
    case MasterType.W2_USER_MEMBER_RANK_HISTORY:
      return w2UserMemberRankHistoryPath(siteId)
    case MasterType.W2_MEMBER_RANK_RULE:
      return w2MemberRankRulePath(siteId)
    case MasterType.W2_ORDER_SHIPPING:
      return w2OrderShippingPath(siteId)
    case MasterType.W2_SHOP_SHIPPING:
      return w2ShopShippingPath(siteId)
    case MasterType.W2_SHOP_SHIPPING_ZONE:
      return w2ShopShippingZonePath(siteId)
    case MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD:
      return w2ShopShippingSizeThresholdPath(siteId)
    case MasterType.W2_MAIL_DIST_SETTING:
      return w2MailDistSettingPath(siteId)
    case MasterType.W2_MAIL_DIST_SENT_USER:
      return w2MailDistSentUserPath(siteId)
    case MasterType.W2_MAIL_SEND_LOG:
      return w2MailSendLogPath(siteId)
    case MasterType.W2_MAIL_CLICK:
      return w2MailClickPath(siteId)
    case MasterType.W2_MAIL_CLICK_LOG:
      return w2MailClickLogPath(siteId)
    case MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING:
      return w2OrderWorkflowScenarioSettingPath(siteId)
    case MasterType.W2_NOVELTY:
      return w2NoveltyPath(siteId)
    case MasterType.W2_NOVELTY_GRANT_CONDITIONS:
      return w2NoveltyGrantConditionsPath(siteId)
    case MasterType.W2_NOVELTY_GRANT_ITEM:
      return w2NoveltyGrantItemPath(siteId)
    case MasterType.W2_NOVELTY_TARGET_ITEM:
      return w2NoveltyTargetItemPath(siteId)
    case MasterType.W2_ORDER_SET_PROMOTION:
      return w2OrderSetPromotionPath(siteId)
    case MasterType.W2_ORDER_SET_PROMOTION_ITEM:
      return w2OrderSetPromotionItemPath(siteId)
    case MasterType.W2_SET_PROMOTION:
      return w2SetPromotionPath(siteId)
    case MasterType.W2_SET_PROMOTION_ITEM:
      return w2SetPromotionItemPath(siteId)
    case MasterType.W2_PRODUCT_BUNDLE:
      return w2ProductBundlePath(siteId)
    case MasterType.W2_PRODUCT_BUNDLE_ITEM:
      return w2ProductBundleItemPath(siteId)
    case MasterType.W2_PRODUCT_SET:
      return w2ProductSetPath(siteId)
    case MasterType.W2_PRODUCT_SET_ITEM:
      return w2ProductSetItemPath(siteId)
    case MasterType.W2_PRODUCT_SALE:
      return w2ProductSalePath(siteId)
    case MasterType.W2_PRODUCT_SALE_PRICE:
      return w2ProductSalePricePath(siteId)
    case MasterType.W2_FIXED_PURCHASE:
      return w2FixedPurchasePath(siteId)
    case MasterType.W2_FIXED_PURCHASE_ITEM:
      return w2FixedPurchaseItemPath(siteId)
    case MasterType.W2_FIXED_PURCHASE_HISTORY:
      return w2FixedPurchaseHistoryPath(siteId)
    case MasterType.W2_FIXED_PURCHASE_CANCEL_REASON:
      return w2FixedPurchaseCancelReasonPath(siteId)
    case MasterType.W2_USER_COUPON:
      return w2UserCouponPath(siteId)
    case MasterType.W2_USER_COUPON_HISTORY:
      return w2UserCouponHistoryPath(siteId)
    case MasterType.W2_COUPON_USE_USER:
      return w2CouponUseUserPath(siteId)
    case MasterType.W2_COUPON_SCHEDULE:
      return w2CouponSchedulePath(siteId)
    case MasterType.W2_ADV_CODE_LOG:
      return w2AdvCodeLogPath(siteId)
    case MasterType.W2_ADV_CODE_MEDIA_TYPE:
      return w2AdvCodeMediaTypePath(siteId)
    case MasterType.W2_USER_ACTIVITY:
      return w2UserActivityPath(siteId)
    case MasterType.W2_AB_TEST:
      return w2AbTestPath(siteId)
    case MasterType.W2_AB_TEST_ITEM:
      return w2AbTestItemPath(siteId)
    case MasterType.W2_PAGE_DESIGN:
      return w2PageDesignPath(siteId)
    case MasterType.W2_PAGE_DESIGN_GROUP:
      return w2PageDesignGroupPath(siteId)
    case MasterType.W2_PARTS_DESIGN:
      return w2PartsDesignPath(siteId)
    case MasterType.W2_PARTS_DESIGN_GROUP:
      return w2PartsDesignGroupPath(siteId)
    case MasterType.W2_FEATURE_AREA:
      return w2FeatureAreaPath(siteId)
    case MasterType.W2_FEATURE_AREA_BANNER:
      return w2FeatureAreaBannerPath(siteId)
    case MasterType.W2_POPUP:
      return w2PopupPath(siteId)
    case MasterType.W2_POPUP_DISPLAY_PAGE_SETTING:
      return w2PopupDisplayPageSettingPath(siteId)
    case MasterType.W2_POPUP_REPORT:
      return w2PopupReportPath(siteId)
  }
  throw new Error('No list page for master type: ' + masterType)
}

export const w2MasterNewPath = (siteId: number, masterType: MasterType): string => {
  switch (masterType) {
    case MasterType.ORDERS:
      return `/sites/${siteId}/orders/new`
    case MasterType.W2_USER:
      return `/sites/${siteId}/w2-users/new`
    case MasterType.W2_USER_ATTRIBUTE:
      return `/sites/${siteId}/w2-user-attributes/new`
    case MasterType.W2_MEMBER_RANK:
      return `/sites/${siteId}/w2-member-ranks/new`
    case MasterType.W2_ACCESS_LOG:
      return `/sites/${siteId}/w2-access-logs/new`
    case MasterType.W2_PRODUCT:
      return `/sites/${siteId}/w2-products/new`
    case MasterType.W2_PRODUCT_BRAND:
      return `/sites/${siteId}/w2-product-brands/new`
    case MasterType.W2_PRODUCT_CATEGORY:
      return `/sites/${siteId}/w2-product-categories/new`
    case MasterType.W2_PRODUCT_TAG:
      return `/sites/${siteId}/w2-product-tags/new`
    case MasterType.W2_PRODUCT_TAG_SETTING:
      return `/sites/${siteId}/w2-product-tag-settings/new`
    case MasterType.W2_PRODUCT_STOCK:
      // 一覧URLは w2-product-inventory なので新規/編集も合わせる
      return `/sites/${siteId}/w2-product-inventory/new`
    case MasterType.W2_PRODUCT_VARIATION:
      return `/sites/${siteId}/w2-product-variation/new`
    case MasterType.W2_PRODUCT_PRICE:
      return `/sites/${siteId}/w2-product-price/new`
    case MasterType.W2_PRODUCT_LINK:
      return `/sites/${siteId}/w2-product-links/new`
    case MasterType.W2_EX_PRODUCT_SPEC:
      return `/sites/${siteId}/w2-ex-product-specs/new`
    case MasterType.W2_EX_PRODUCT_VARIATION_SPEC:
      return `/sites/${siteId}/w2-ex-product-variation-specs/new`
    case MasterType.W2_CART:
      return `/sites/${siteId}/w2-cart/new`
    case MasterType.W2_ORDER:
      return `/sites/${siteId}/w2-orders/new`
    case MasterType.W2_ORDER_ITEM:
      return `/sites/${siteId}/w2-order-details/new`
    case MasterType.W2_ORDER_COUPON:
      return `/sites/${siteId}/w2-order-coupons/new`
    case MasterType.W2_COUPON:
      return `/sites/${siteId}/w2-coupons/new`
    case MasterType.W2_ADV_CODE:
      return `/sites/${siteId}/w2-advcodes/new`
    case MasterType.W2_FEATURE_PAGE:
      return `/sites/${siteId}/w2-features/new`
    case MasterType.W2_FEATURE_PAGE_CATEGORY:
      return `/sites/${siteId}/w2-feature-categories/new`
    case MasterType.W2_FEATURE_PAGE_CONTENTS:
      return `/sites/${siteId}/w2-feature-contents/new`
    case MasterType.W2_PRODUCT_GROUP:
      return `/sites/${siteId}/w2-product-groups/new`
    case MasterType.W2_PRODUCT_GROUP_ITEM:
      return `/sites/${siteId}/w2-product-group-items/new`
    case MasterType.W2_CONTENTS_TAG:
      return `/sites/${siteId}/w2-contents-tags/new`
    case MasterType.W2_USER_POINT:
      return `/sites/${siteId}/w2-user-point/new`
    case MasterType.W2_USER_POINT_HISTORY:
      return `/sites/${siteId}/w2-user-point-history/new`
    case MasterType.W2_POINT_RULE:
      return `/sites/${siteId}/w2-point-rule/new`
    case MasterType.W2_POINT_RULE_SCHEDULE:
      return `/sites/${siteId}/w2-point-rule-schedule/new`
    case MasterType.W2_USER_MEMBER_RANK_HISTORY:
      return `/sites/${siteId}/w2-user-member-rank-history/new`
    case MasterType.W2_MEMBER_RANK_RULE:
      return `/sites/${siteId}/w2-member-rank-rule/new`
    case MasterType.W2_ORDER_SHIPPING:
      return `/sites/${siteId}/w2-order-shipping/new`
    case MasterType.W2_SHOP_SHIPPING:
      return `/sites/${siteId}/w2-shop-shipping/new`
    case MasterType.W2_SHOP_SHIPPING_ZONE:
      return `/sites/${siteId}/w2-shop-shipping-zone/new`
    case MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD:
      return `/sites/${siteId}/w2-shop-shipping-size-threshold/new`
    case MasterType.W2_MAIL_DIST_SETTING:
      return `/sites/${siteId}/w2-mail-dist-setting/new`
    case MasterType.W2_MAIL_DIST_SENT_USER:
      return `/sites/${siteId}/w2-mail-dist-sent-user/new`
    case MasterType.W2_MAIL_SEND_LOG:
      return `/sites/${siteId}/w2-mail-send-log/new`
    case MasterType.W2_MAIL_CLICK:
      return `/sites/${siteId}/w2-mail-click/new`
    case MasterType.W2_MAIL_CLICK_LOG:
      return `/sites/${siteId}/w2-mail-click-log/new`
    case MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING:
      return `/sites/${siteId}/w2-order-workflow-scenario-setting/new`
    case MasterType.W2_NOVELTY:
      return `/sites/${siteId}/w2-novelty/new`
    case MasterType.W2_NOVELTY_GRANT_CONDITIONS:
      return `/sites/${siteId}/w2-novelty-grant-conditions/new`
    case MasterType.W2_NOVELTY_GRANT_ITEM:
      return `/sites/${siteId}/w2-novelty-grant-item/new`
    case MasterType.W2_NOVELTY_TARGET_ITEM:
      return `/sites/${siteId}/w2-novelty-target-item/new`
    case MasterType.W2_ORDER_SET_PROMOTION:
      return `/sites/${siteId}/w2-order-setpromotion/new`
    case MasterType.W2_ORDER_SET_PROMOTION_ITEM:
      return `/sites/${siteId}/w2-order-setpromotion-item/new`
    case MasterType.W2_SET_PROMOTION:
      return `/sites/${siteId}/w2-setpromotion/new`
    case MasterType.W2_SET_PROMOTION_ITEM:
      return `/sites/${siteId}/w2-setpromotion-item/new`
    case MasterType.W2_PRODUCT_BUNDLE:
      return `/sites/${siteId}/w2-product-bundle/new`
    case MasterType.W2_PRODUCT_BUNDLE_ITEM:
      return `/sites/${siteId}/w2-product-bundle-item/new`
    case MasterType.W2_PRODUCT_SET:
      return `/sites/${siteId}/w2-product-set/new`
    case MasterType.W2_PRODUCT_SET_ITEM:
      return `/sites/${siteId}/w2-product-set-item/new`
    case MasterType.W2_PRODUCT_SALE:
      return `/sites/${siteId}/w2-product-sale/new`
    case MasterType.W2_PRODUCT_SALE_PRICE:
      return `/sites/${siteId}/w2-product-sale-price/new`
    case MasterType.W2_FIXED_PURCHASE:
      return `/sites/${siteId}/w2-fixed-purchase/new`
    case MasterType.W2_FIXED_PURCHASE_ITEM:
      return `/sites/${siteId}/w2-fixed-purchase-item/new`
    case MasterType.W2_FIXED_PURCHASE_HISTORY:
      return `/sites/${siteId}/w2-fixed-purchase-history/new`
    case MasterType.W2_FIXED_PURCHASE_CANCEL_REASON:
      return `/sites/${siteId}/w2-fixed-purchase-cancel-reason/new`
    case MasterType.W2_USER_COUPON:
      return `/sites/${siteId}/w2-user-coupon/new`
    case MasterType.W2_USER_COUPON_HISTORY:
      return `/sites/${siteId}/w2-user-coupon-history/new`
    case MasterType.W2_COUPON_USE_USER:
      return `/sites/${siteId}/w2-coupon-use-user/new`
    case MasterType.W2_COUPON_SCHEDULE:
      return `/sites/${siteId}/w2-coupon-schedule/new`
    case MasterType.W2_ADV_CODE_LOG:
      return `/sites/${siteId}/w2-advcode-log/new`
    case MasterType.W2_ADV_CODE_MEDIA_TYPE:
      return `/sites/${siteId}/w2-advcode-media-type/new`
    case MasterType.W2_USER_ACTIVITY:
      return `/sites/${siteId}/w2-user-activity/new`
    case MasterType.W2_AB_TEST:
      return `/sites/${siteId}/w2-ab-test/new`
    case MasterType.W2_AB_TEST_ITEM:
      return `/sites/${siteId}/w2-ab-test-item/new`
    case MasterType.W2_PAGE_DESIGN:
      return `/sites/${siteId}/w2-page-design/new`
    case MasterType.W2_PAGE_DESIGN_GROUP:
      return `/sites/${siteId}/w2-page-design-group/new`
    case MasterType.W2_PARTS_DESIGN:
      return `/sites/${siteId}/w2-parts-design/new`
    case MasterType.W2_PARTS_DESIGN_GROUP:
      return `/sites/${siteId}/w2-parts-design-group/new`
    case MasterType.W2_FEATURE_AREA:
      return `/sites/${siteId}/w2-feature-area/new`
    case MasterType.W2_FEATURE_AREA_BANNER:
      return `/sites/${siteId}/w2-feature-area-banner/new`
    case MasterType.W2_POPUP:
      return `/sites/${siteId}/w2-popup/new`
    case MasterType.W2_POPUP_DISPLAY_PAGE_SETTING:
      return `/sites/${siteId}/w2-popup-display-page-setting/new`
    case MasterType.W2_POPUP_REPORT:
      return `/sites/${siteId}/w2-popup-report/new`
  }
  throw new Error('No New page for master type: ' + masterType)
}

export const w2MasterEditPath = (siteId: number, masterType: MasterType, id: number): string => {
  switch (masterType) {
    case MasterType.ORDERS:
      return `/sites/${siteId}/orders/edit/${id}`
    case MasterType.W2_USER:
      return `/sites/${siteId}/w2-users/edit/${id}`
    case MasterType.W2_USER_ATTRIBUTE:
      return `/sites/${siteId}/w2-user-attributes/edit/${id}`
    case MasterType.W2_MEMBER_RANK:
      return `/sites/${siteId}/w2-member-ranks/edit/${id}`
    case MasterType.W2_ACCESS_LOG:
      return `/sites/${siteId}/w2-access-logs/edit/${id}`
    case MasterType.W2_PRODUCT:
      return `/sites/${siteId}/w2-products/edit/${id}`
    case MasterType.W2_PRODUCT_BRAND:
      return `/sites/${siteId}/w2-product-brands/edit/${id}`
    case MasterType.W2_PRODUCT_CATEGORY:
      return `/sites/${siteId}/w2-product-categories/edit/${id}`
    case MasterType.W2_PRODUCT_TAG:
      return `/sites/${siteId}/w2-product-tags/edit/${id}`
    // 新規は規約（.claude/rules/frontend.md）に従い <resource>/:id/edit の形にする
    case MasterType.W2_PRODUCT_TAG_SETTING:
      return `/sites/${siteId}/w2-product-tag-settings/${id}/edit`
    case MasterType.W2_PRODUCT_STOCK:
      return `/sites/${siteId}/w2-product-inventory/edit/${id}`
    case MasterType.W2_PRODUCT_VARIATION:
      return `/sites/${siteId}/w2-product-variation/edit/${id}`
    case MasterType.W2_PRODUCT_PRICE:
      return `/sites/${siteId}/w2-product-price/edit/${id}`
    case MasterType.W2_PRODUCT_LINK:
      return `/sites/${siteId}/w2-product-links/edit/${id}`
    // 拡張マスタは規約（.claude/rules/frontend.md）に従い <resource>/:id/edit の形にする
    case MasterType.W2_EX_PRODUCT_SPEC:
      return `/sites/${siteId}/w2-ex-product-specs/${id}/edit`
    case MasterType.W2_EX_PRODUCT_VARIATION_SPEC:
      return `/sites/${siteId}/w2-ex-product-variation-specs/${id}/edit`
    case MasterType.W2_CART:
      return `/sites/${siteId}/w2-cart/edit/${id}`
    case MasterType.W2_ORDER:
      return `/sites/${siteId}/w2-orders/edit/${id}`
    case MasterType.W2_ORDER_ITEM:
      return `/sites/${siteId}/w2-order-details/edit/${id}`
    case MasterType.W2_ORDER_COUPON:
      return `/sites/${siteId}/w2-order-coupons/edit/${id}`
    case MasterType.W2_COUPON:
      return `/sites/${siteId}/w2-coupons/edit/${id}`
    case MasterType.W2_ADV_CODE:
      return `/sites/${siteId}/w2-advcodes/edit/${id}`
    case MasterType.W2_FEATURE_PAGE:
      return `/sites/${siteId}/w2-features/edit/${id}`
    case MasterType.W2_FEATURE_PAGE_CATEGORY:
      return `/sites/${siteId}/w2-feature-categories/edit/${id}`
    case MasterType.W2_FEATURE_PAGE_CONTENTS:
      return `/sites/${siteId}/w2-feature-contents/edit/${id}`
    case MasterType.W2_PRODUCT_GROUP:
      return `/sites/${siteId}/w2-product-groups/edit/${id}`
    case MasterType.W2_PRODUCT_GROUP_ITEM:
      return `/sites/${siteId}/w2-product-group-items/edit/${id}`
    case MasterType.W2_CONTENTS_TAG:
      return `/sites/${siteId}/w2-contents-tags/edit/${id}`
    case MasterType.W2_USER_POINT:
      return `/sites/${siteId}/w2-user-point/edit/${id}`
    case MasterType.W2_USER_POINT_HISTORY:
      return `/sites/${siteId}/w2-user-point-history/edit/${id}`
    case MasterType.W2_POINT_RULE:
      return `/sites/${siteId}/w2-point-rule/edit/${id}`
    case MasterType.W2_POINT_RULE_SCHEDULE:
      return `/sites/${siteId}/w2-point-rule-schedule/edit/${id}`
    case MasterType.W2_USER_MEMBER_RANK_HISTORY:
      return `/sites/${siteId}/w2-user-member-rank-history/edit/${id}`
    case MasterType.W2_MEMBER_RANK_RULE:
      return `/sites/${siteId}/w2-member-rank-rule/edit/${id}`
    case MasterType.W2_ORDER_SHIPPING:
      return `/sites/${siteId}/w2-order-shipping/edit/${id}`
    case MasterType.W2_SHOP_SHIPPING:
      return `/sites/${siteId}/w2-shop-shipping/edit/${id}`
    case MasterType.W2_SHOP_SHIPPING_ZONE:
      return `/sites/${siteId}/w2-shop-shipping-zone/edit/${id}`
    case MasterType.W2_SHOP_SHIPPING_SIZE_THRESHOLD:
      return `/sites/${siteId}/w2-shop-shipping-size-threshold/edit/${id}`
    case MasterType.W2_MAIL_DIST_SETTING:
      return `/sites/${siteId}/w2-mail-dist-setting/edit/${id}`
    case MasterType.W2_MAIL_DIST_SENT_USER:
      return `/sites/${siteId}/w2-mail-dist-sent-user/edit/${id}`
    case MasterType.W2_MAIL_SEND_LOG:
      return `/sites/${siteId}/w2-mail-send-log/edit/${id}`
    case MasterType.W2_MAIL_CLICK:
      return `/sites/${siteId}/w2-mail-click/edit/${id}`
    case MasterType.W2_MAIL_CLICK_LOG:
      return `/sites/${siteId}/w2-mail-click-log/edit/${id}`
    case MasterType.W2_ORDER_WORKFLOW_SCENARIO_SETTING:
      return `/sites/${siteId}/w2-order-workflow-scenario-setting/edit/${id}`
    case MasterType.W2_NOVELTY:
      return `/sites/${siteId}/w2-novelty/edit/${id}`
    case MasterType.W2_NOVELTY_GRANT_CONDITIONS:
      return `/sites/${siteId}/w2-novelty-grant-conditions/edit/${id}`
    case MasterType.W2_NOVELTY_GRANT_ITEM:
      return `/sites/${siteId}/w2-novelty-grant-item/edit/${id}`
    case MasterType.W2_NOVELTY_TARGET_ITEM:
      return `/sites/${siteId}/w2-novelty-target-item/edit/${id}`
    case MasterType.W2_ORDER_SET_PROMOTION:
      return `/sites/${siteId}/w2-order-setpromotion/edit/${id}`
    case MasterType.W2_ORDER_SET_PROMOTION_ITEM:
      return `/sites/${siteId}/w2-order-setpromotion-item/edit/${id}`
    case MasterType.W2_SET_PROMOTION:
      return `/sites/${siteId}/w2-setpromotion/edit/${id}`
    case MasterType.W2_SET_PROMOTION_ITEM:
      return `/sites/${siteId}/w2-setpromotion-item/edit/${id}`
    case MasterType.W2_PRODUCT_BUNDLE:
      return `/sites/${siteId}/w2-product-bundle/edit/${id}`
    case MasterType.W2_PRODUCT_BUNDLE_ITEM:
      return `/sites/${siteId}/w2-product-bundle-item/edit/${id}`
    case MasterType.W2_PRODUCT_SET:
      return `/sites/${siteId}/w2-product-set/edit/${id}`
    case MasterType.W2_PRODUCT_SET_ITEM:
      return `/sites/${siteId}/w2-product-set-item/edit/${id}`
    case MasterType.W2_PRODUCT_SALE:
      return `/sites/${siteId}/w2-product-sale/edit/${id}`
    case MasterType.W2_PRODUCT_SALE_PRICE:
      return `/sites/${siteId}/w2-product-sale-price/edit/${id}`
    case MasterType.W2_FIXED_PURCHASE:
      return `/sites/${siteId}/w2-fixed-purchase/edit/${id}`
    case MasterType.W2_FIXED_PURCHASE_ITEM:
      return `/sites/${siteId}/w2-fixed-purchase-item/edit/${id}`
    case MasterType.W2_FIXED_PURCHASE_HISTORY:
      return `/sites/${siteId}/w2-fixed-purchase-history/edit/${id}`
    case MasterType.W2_FIXED_PURCHASE_CANCEL_REASON:
      return `/sites/${siteId}/w2-fixed-purchase-cancel-reason/edit/${id}`
    case MasterType.W2_USER_COUPON:
      return `/sites/${siteId}/w2-user-coupon/edit/${id}`
    case MasterType.W2_USER_COUPON_HISTORY:
      return `/sites/${siteId}/w2-user-coupon-history/edit/${id}`
    case MasterType.W2_COUPON_USE_USER:
      return `/sites/${siteId}/w2-coupon-use-user/edit/${id}`
    case MasterType.W2_COUPON_SCHEDULE:
      return `/sites/${siteId}/w2-coupon-schedule/edit/${id}`
    case MasterType.W2_ADV_CODE_LOG:
      return `/sites/${siteId}/w2-advcode-log/edit/${id}`
    case MasterType.W2_ADV_CODE_MEDIA_TYPE:
      return `/sites/${siteId}/w2-advcode-media-type/edit/${id}`
    case MasterType.W2_USER_ACTIVITY:
      return `/sites/${siteId}/w2-user-activity/edit/${id}`
    case MasterType.W2_AB_TEST:
      return `/sites/${siteId}/w2-ab-test/edit/${id}`
    case MasterType.W2_AB_TEST_ITEM:
      return `/sites/${siteId}/w2-ab-test-item/edit/${id}`
    case MasterType.W2_PAGE_DESIGN:
      return `/sites/${siteId}/w2-page-design/edit/${id}`
    case MasterType.W2_PAGE_DESIGN_GROUP:
      return `/sites/${siteId}/w2-page-design-group/edit/${id}`
    case MasterType.W2_PARTS_DESIGN:
      return `/sites/${siteId}/w2-parts-design/edit/${id}`
    case MasterType.W2_PARTS_DESIGN_GROUP:
      return `/sites/${siteId}/w2-parts-design-group/edit/${id}`
    case MasterType.W2_FEATURE_AREA:
      return `/sites/${siteId}/w2-feature-area/edit/${id}`
    case MasterType.W2_FEATURE_AREA_BANNER:
      return `/sites/${siteId}/w2-feature-area-banner/edit/${id}`
    case MasterType.W2_POPUP:
      return `/sites/${siteId}/w2-popup/edit/${id}`
    case MasterType.W2_POPUP_DISPLAY_PAGE_SETTING:
      return `/sites/${siteId}/w2-popup-display-page-setting/edit/${id}`
    case MasterType.W2_POPUP_REPORT:
      return `/sites/${siteId}/w2-popup-report/edit/${id}`
  }
  throw new Error('No Edit page for master type: ' + masterType)
}

// ===== UGC Intelligence routes =====

export const ugcDashboardPath = (siteId: number) => `/sites/${siteId}/ugc-dashboard`

// 将来フェーズ6機能をまとめて見せる。個別にメニューへ並べない

export const ugcGuidePath = (siteId: number) => `/sites/${siteId}/ugc-guide`

export const ugcReviewsPath = (siteId: number) => `/sites/${siteId}/ugc-reviews`

export const ugcInstagramPath = (siteId: number) => `/sites/${siteId}/ugc-instagram`

export const ugcInstagramSettingsPath = (siteId: number) =>
  `/sites/${siteId}/ugc-instagram-settings`

export const ugcMailPath = (siteId: number) => `/sites/${siteId}/ugc-mail`

export const ugcAiScorePath = (siteId: number) => `/sites/${siteId}/ugc-ai-score`

export const ugcDisplayRulesPath = (siteId: number) => `/sites/${siteId}/ugc-display-rules`

export const ugcDisplayRuleNewPath = (siteId: number) => `/sites/${siteId}/ugc-display-rules/new`

export const ugcDisplayRuleEditPath = (siteId: number, ruleId: number) =>
  `/sites/${siteId}/ugc-display-rules/edit/${ruleId}`

export const ugcProductTaggingPath = (siteId: number) => `/sites/${siteId}/ugc-product-tagging`

export const ugcSeoPath = (siteId: number) => `/sites/${siteId}/ugc-seo`

export const ugcTagEmbedPath = (siteId: number) => `/sites/${siteId}/ugc-tag-embed`

export const ugcCvrPath = (siteId: number) => `/sites/${siteId}/ugc-cvr`

export const ugcVocPath = (siteId: number) => `/sites/${siteId}/ugc-voc`

export const ugcWearPath = (siteId: number) => `/sites/${siteId}/ugc-wear`

export const ugcGiftingPath = (siteId: number) => `/sites/${siteId}/ugc-gifting`

export const ugcStaffPath = (siteId: number) => `/sites/${siteId}/ugc-staff`

export const ugcQaPath = (siteId: number) => `/sites/${siteId}/ugc-qa`

export const ugcVideoPath = (siteId: number) => `/sites/${siteId}/ugc-video`

export const ugcOmoPath = (siteId: number) => `/sites/${siteId}/ugc-omo`

export const ugcCompliancePath = (siteId: number) => `/sites/${siteId}/ugc-compliance`

export const ugcPortalPath = (siteId: number) => `/sites/${siteId}/ugc-portal`

// ===== Media-DRIVER routes =====

export const mediaDashboardPath = (siteId: number) => `/sites/${siteId}/media/dashboard`

export const mediaAnalysisAutomationPath = (siteId: number) =>
  `/sites/${siteId}/media/analysis-automation`

export const mediaActionPath = (siteId: number, condition?: Partial<MediaActionSearchCondition>) =>
  `/sites/${siteId}/media/action` + (condition ? makeParamsQueryStr(condition) : '')

export const analysisTargetPath = (siteId: number) => `/sites/${siteId}/media/analysis-target`

export const analysisTargetNewPath = (siteId: number) =>
  `/sites/${siteId}/media/analysis-target/new`

export const analysisTargetEditPath = (siteId: number, targetId: number) =>
  `/sites/${siteId}/media/analysis-target/${targetId}/edit`

// ===== AI学習用データ（media-ai-training-data） =====

export const mediaAiTrainingDataPath = (siteId: number) =>
  `/sites/${siteId}/media/ai-training-data`

export const mediaAiTrainingDataArticleHtmlPath = (siteId: number) =>
  `/sites/${siteId}/media/ai-training-data/article-html`

export const mediaAiTrainingDataCommonRulesPath = (siteId: number) =>
  `/sites/${siteId}/media/ai-training-data/common-rules`

// ===== 記事管理（media-article） =====

export const articleListPath = (siteId: number, condition?: Partial<ArticleSearchCondition>) => {
  return `/sites/${siteId}/media/articles` + (condition ? makeParamsQueryStr(condition) : '')
}

export const articleDetailPath = (siteId: number, articleProposalId: number) =>
  `/sites/${siteId}/media/articles/${articleProposalId}`

export const articleNewPath = (siteId: number) => `/sites/${siteId}/media/articles/new`

export const articleEditPath = (
  siteId: number,
  articleProposalId: number,
  options?: { openAiRewrite: boolean }
) =>
  `/sites/${siteId}/media/articles/${articleProposalId}/edit` +
  (options?.openAiRewrite ? '?openAiRewrite=1' : '')

export const articleAnalysisListPath = (siteId: number) =>
  `/sites/${siteId}/media/articles/analysis`

export const articleApprovalListPath = (siteId: number) => `/sites/${siteId}/media/articles/uploads`

export const articleApprovalDetailPath = (siteId: number, requestId: number) =>
  `/sites/${siteId}/media/articles/uploads/${requestId}`

// ===== サイト現状分析（media-analysis） =====

export const mediaAnalysisPath = (siteId: number) => `/sites/${siteId}/media/analysis`

export const mediaAnalysisHistoryPath = (siteId: number) =>
  `/sites/${siteId}/media/analysis/history`

export const mediaGscLinkagePath = (siteId: number) => `/sites/${siteId}/media/gsc-linkage`

export const mediaAnalysisCompetitorResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/competitor/${historyId}/result`

export const mediaAnalysisSerpResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/serp/${historyId}/result`

export const mediaAnalysisGapResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/gap/${historyId}/result`

export const mediaAnalysisCannibalizationResultPath = (
  siteId: number,
  historyId: number | string
) => `/sites/${siteId}/media/analysis/cannibalization/${historyId}/result`

export const mediaAnalysisLinkStructureResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/link-structure/${historyId}/result`

export const mediaAnalysisCitationResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/citation/${historyId}/result`

export const mediaAnalysisShareOfVoiceResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/share-of-voice/${historyId}/result`

export const mediaAnalysisSentimentResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/sentiment/${historyId}/result`

export const mediaAnalysisQueryFanoutResultPath = (siteId: number, historyId: number | string) =>
  `/sites/${siteId}/media/analysis/query-fanout/${historyId}/result`

// analysis_type(9種別のkey) から対応する結果詳細パスを引く
export const mediaAnalysisResultPath = (
  siteId: number,
  analysisType: MediaAnalysisType,
  historyId: number | string
): string => {
  switch (analysisType) {
    case MediaAnalysisType.COMPETITOR:
      return mediaAnalysisCompetitorResultPath(siteId, historyId)
    case MediaAnalysisType.COMPETITOR_SERP:
      return mediaAnalysisSerpResultPath(siteId, historyId)
    case MediaAnalysisType.CONTENT_GAP:
      return mediaAnalysisGapResultPath(siteId, historyId)
    case MediaAnalysisType.CANNIBALIZATION:
      return mediaAnalysisCannibalizationResultPath(siteId, historyId)
    case MediaAnalysisType.LINK_STRUCTURE:
      return mediaAnalysisLinkStructureResultPath(siteId, historyId)
    case MediaAnalysisType.CITATION:
      return mediaAnalysisCitationResultPath(siteId, historyId)
    case MediaAnalysisType.SHARE_OF_VOICE:
      return mediaAnalysisShareOfVoiceResultPath(siteId, historyId)
    case MediaAnalysisType.SENTIMENT:
      return mediaAnalysisSentimentResultPath(siteId, historyId)
    case MediaAnalysisType.QUERY_FANOUT:
      return mediaAnalysisQueryFanoutResultPath(siteId, historyId)
    default:
      throw new Error('No result page for analysis type: ' + analysisType)
  }
}

// ===== AI Purchase Assist routes =====

export const aiPurchaseAssistPath = (siteId: number) => `/sites/${siteId}/ai-purchase-assist`

export const aiPurchaseAssistCampaignsPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/campaigns`

export const aiPurchaseAssistRichUIPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/rich-ui`

export const aiPurchaseAssistAbTestsPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/ab-tests`

export const aiPurchaseAssistConversationsPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/conversations`

export const aiPurchaseAssistFeedbackPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/feedback`

export const aiPurchaseAssistKnowledgePath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/knowledge`

export const aiPurchaseAssistOpeningsPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/openings`

export const aiPurchaseAssistAiProfilesPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/ai-profiles`

export const aiPurchaseAssistNgRulesPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/ng-rules`

export const aiPurchaseAssistVectorSourcesPath = (siteId: number) =>
  `/sites/${siteId}/ai-purchase-assist/vector-sources`

// 検索サジェスト（Findee）
export const searchSuggestPath = (siteId: number) => `/sites/${siteId}/search-suggest`

export const searchSuggestSettingsPath = (siteId: number) =>
  `/sites/${siteId}/search-suggest/settings`

export const searchSuggestDictionaryPath = (siteId: number) =>
  `/sites/${siteId}/search-suggest/dictionary`

export const searchSuggestAnalyticsPath = (siteId: number) =>
  `/sites/${siteId}/search-suggest/analytics`

// 検索タグ
export const searchTagPath = (siteId: number) => `/sites/${siteId}/search-tags`

export const searchTagDashboardPath = (siteId: number) => `/sites/${siteId}/search-tags/dashboard`

export const searchTagCandidatesPath = (siteId: number) => `/sites/${siteId}/search-tags/candidates`

export const searchTagListPath = (siteId: number) => `/sites/${siteId}/search-tags/tags`

export const searchTagOptimizationsPath = (siteId: number) =>
  `/sites/${siteId}/search-tags/optimizations`

export const searchTagDeliveryPath = (siteId: number) => `/sites/${siteId}/search-tags/delivery`

export const searchTagSettingsPath = (siteId: number) => `/sites/${siteId}/search-tags/settings`
